module.exports = __webpack_public_path__ + "img/newspaper.802e375a.png";